import { __assign, __read, __spreadArray } from "tslib";
import addDays from 'date-fns/add_days';
import differenceInDays from 'date-fns/difference_in_days';
import format from 'date-fns/format';
import { default as Calendar } from './Calendar';
import { default as Currency } from './Currency';
import { default as UrlMapper } from './UrlMapper';
import InputValueMapper from './InputValueMapper';
import { ProductTypeHelper, SearchMaskGroupType, SearchMaskInputType, store, UserInputValueToCoreMapper, websiteActions, } from 'ltur-state-engine';
import Vue from 'vue-ltur';
import { getOptionsFromFormData } from "Helper/State";
import { STATE, StateHelper } from "Helper/StateHelper";
var InputValueSetup = /** @class */ (function () {
    function InputValueSetup() {
        this.searchMaskGroups = {};
        this.searchMaskBundle = { initialized: true, groups: {} };
    }
    InputValueSetup.prototype.initializePackage = function () {
        var _this = this;
        setTimeout(function () {
            var _a;
            var _b, _c, _d, _e, _f;
            var state = store.getState();
            var formData = state.coreState.package.formData;
            var productQuery = state.websiteState.app.url.productQuery;
            var options = state.websiteState.app.url.productOptions;
            var query = state.websiteState.app.url.query;
            var productGroupId = state.websiteState.app.url.productGroupId;
            var productType = state.websiteState.app.url.context.productType;
            var settingsCMS = state.cmsState.api.response.settings;
            var keepPreviousSearch = (_b = settingsCMS.KeepSearchTab) !== null && _b !== void 0 ? _b : false;
            if (window.location.pathname.indexOf('de/hotel/weltweit') >= 0
                || window.location.pathname.indexOf('de/hotel/deutschland') >= 0) {
                keepPreviousSearch = true;
            }
            var searchMaskBundle = state.websiteState.searchMask.searchMaskBundle;
            if (!searchMaskBundle) {
                searchMaskBundle = _this.searchMaskBundle;
            }
            if (typeof searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] !== 'undefined' && searchMaskBundle.groups[SearchMaskGroupType.PACKAGE].initialized) {
                return;
            }
            var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
            if (searchMaskGroupType === 'HOTEL') {
                _this.initializeHotel();
            }
            Vue.dispatch(websiteActions.setActiveTabSearchMask(searchMaskGroupType));
            var airportInitValue = {
                uiValue: Vue.translate('any'),
                value: [],
            };
            var departureAirportParsed = JSON.parse(sessionStorage.getItem('searchmask.departureAirport'));
            var airportCodes = [];
            var airportGroupCodes = [];
            if (keepPreviousSearch
                && departureAirportParsed !== null
                && departureAirportParsed.length !== 0
                && departureAirportParsed[0].hasOwnProperty('code')) {
                airportCodes = _this.extractAirportCodes(departureAirportParsed);
            }
            else if (keepPreviousSearch
                && departureAirportParsed !== null
                && departureAirportParsed.length !== 0
                && departureAirportParsed[0].hasOwnProperty('id')) {
                departureAirportParsed.forEach(function (element) {
                    airportGroupCodes.push(element.id);
                });
            }
            if (typeof productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] === 'undefined'
                && typeof settingsCMS.productSearch.productQuery['flightDepartureAirportCodes'] !== 'undefined') {
                productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] = settingsCMS.productSearch.productQuery['flightDepartureAirportCodes'];
            }
            if (airportCodes.length > 0 && keepPreviousSearch) {
                productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] = airportCodes;
            }
            if (typeof productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS'] === 'undefined'
                && typeof settingsCMS.productSearch.productQuery['flightDepartureAirportGroups'] !== 'undefined') {
                productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS'] = settingsCMS.productSearch.productQuery['flightDepartureAirportGroups'];
            }
            if (airportGroupCodes.length > 0 && keepPreviousSearch) {
                productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS'] = airportGroupCodes;
            }
            productQuery = _this.addSettingsCmsToProductQuery(formData, settingsCMS, productQuery);
            if (typeof settingsCMS.productGroups !== 'undefined'
                && settingsCMS.productGroups.length) {
                productGroupId = (settingsCMS.productGroups[0].id).toString();
            }
            var airportInitValueConfirmedValue = UrlMapper.mapDepartureAirport(formData.departureAirportGroups, JSON.parse(JSON.stringify(airportInitValue)), searchMaskGroupType, productQuery);
            var destinationInitValue = {
                uiValue: Vue.translate('any'),
                value: [],
            };
            var destinationCoreQuery = UrlMapper.mapDestinationCoreQuery(productQuery);
            var dynamicDepartureDateDaysSetting = (_c = settingsCMS.travelPeriodDepartureDateDynamicOffset) !== null && _c !== void 0 ? _c : null;
            var departureDateResult = formData.travelPeriod.departureDate.default;
            departureDateResult = _this.modifyDepartureDateUsingDynamicDate(dynamicDepartureDateDaysSetting, departureDateResult);
            var dynamicReturnDateDaysSetting = (_d = settingsCMS.travelPeriodReturnDateDynamicOffset) !== null && _d !== void 0 ? _d : null;
            var returnDateResult = formData.travelPeriod.returnDate.default;
            returnDateResult = _this.modifyReturnDateUsingDynamicDate(dynamicReturnDateDaysSetting, returnDateResult);
            var travelPeriodDefaultUIValue = __assign({}, Calendar.getTravelPeriodUIValue(departureDateResult, returnDateResult, false, false, false));
            var datePicker = (_e = sessionStorage.getItem('searchmask.datePicker')) !== null && _e !== void 0 ? _e : '';
            var datePickerParsed = null;
            if (datePicker !== '' && keepPreviousSearch && !_this.urlIsLastMinute()) {
                datePickerParsed = JSON.parse(datePicker);
                returnDateResult = datePickerParsed.end;
                departureDateResult = datePickerParsed.start;
            }
            var travelPeriodDefaultValue = {
                uiValue: travelPeriodDefaultUIValue,
                value: {
                    datePickerIsOpen: false,
                    departureDate: departureDateResult,
                    departureDateFull: departureDateResult,
                    departureDateActive: false,
                    exactDepartureDate: settingsCMS.exactDepartureDate,
                    departureDays: [],
                    duration: formData.travelPeriod.duration.default,
                    exactDuration: false,
                    returnDate: returnDateResult,
                    returnDateFull: returnDateResult,
                    returnDateActive: false,
                    triggerInitFlow: false,
                    preferredDepartureDate: null
                }
            };
            var travelPeriodConfirmedValue = JSON.parse(JSON.stringify(travelPeriodDefaultValue));
            travelPeriodConfirmedValue.uiValue = UrlMapper.mapTravelPeriodUIValue(formData, travelPeriodDefaultUIValue, productQuery);
            travelPeriodConfirmedValue.value.exactDepartureDate = UrlMapper.mapExactDepartureDate(travelPeriodDefaultValue.value.exactDepartureDate, productQuery);
            travelPeriodConfirmedValue.value.departureDate = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDate, productQuery);
            travelPeriodConfirmedValue.value.departureDateFull = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDateFull, productQuery);
            // Setting departure date today without exactDeparture date is not permitted
            if (!travelPeriodConfirmedValue.value.exactDepartureDate &&
                new Date(travelPeriodConfirmedValue.value.departureDate).getTime() < new Date().setHours(24, 0, 0, 0)) {
                travelPeriodConfirmedValue.value.departureDate = format(addDays(new Date(), 1), 'YYYY-MM-DD');
                travelPeriodConfirmedValue.value.departureDateFull = format(addDays(new Date(), 1), 'YYYY-MM-DD');
            }
            travelPeriodConfirmedValue.value.departureDays = UrlMapper.mapTravelPeriodValueDepartureDays(travelPeriodDefaultValue.value.departureDays, productQuery);
            travelPeriodConfirmedValue.value.returnDate = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDate, productQuery);
            travelPeriodConfirmedValue.value.returnDateFull = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDateFull, productQuery);
            travelPeriodConfirmedValue.value.exactDuration = UrlMapper.mapTravelPeriodValueExactDuration(query, travelPeriodDefaultValue.value.exactDuration);
            travelPeriodConfirmedValue.value.preferredDepartureDate = UrlMapper.mapTravelPeriodValuePreferredDepartureDate(travelPeriodDefaultValue.value.preferredDepartureDate, productQuery);
            travelPeriodConfirmedValue.uiValue.duration =
                Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, formData.travelPeriod.duration.default);
            travelPeriodConfirmedValue.value.duration =
                UrlMapper.mapTravelPeriodValueDuration(travelPeriodDefaultValue.value.duration, productQuery);
            if (typeof settingsCMS.productSearch.productQuery.travelPeriodDuration !== 'undefined') {
                travelPeriodConfirmedValue.uiValue.duration =
                    Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, settingsCMS.productSearch.productQuery.travelPeriodDuration);
                travelPeriodConfirmedValue.value.duration =
                    UrlMapper.mapTravelPeriodValueDuration(settingsCMS.productSearch.productQuery.travelPeriodDuration, productQuery);
            }
            travelPeriodConfirmedValue.uiValue.duration =
                UrlMapper.mapTravelPeriodUIValueDuration(formData, travelPeriodDefaultValue.uiValue.duration, productQuery);
            if (travelPeriodConfirmedValue.value.exactDuration) {
                var duration = differenceInDays(travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDate);
                if (duration > 28) {
                    travelPeriodConfirmedValue.value.returnDate =
                        format(addDays(travelPeriodConfirmedValue.value.departureDate, 28), 'YYYY-MM-DD');
                    duration = 28;
                }
                travelPeriodConfirmedValue.value.duration = Calendar.getDurationValue(duration);
                travelPeriodConfirmedValue.uiValue = Calendar.getTravelPeriodUIValue(travelPeriodConfirmedValue.value.departureDate, travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDateActive, travelPeriodConfirmedValue.value.returnDateActive, travelPeriodConfirmedValue.value.exactDuration);
                travelPeriodConfirmedValue.uiValue.duration = Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, travelPeriodConfirmedValue.value.duration);
            }
            var numberOfAdults = formData.travellers.adults.default;
            var ageOfChildren = formData.travellers.children.default;
            var storageTravellers = (_f = sessionStorage.getItem('searchmask.travellers')) !== null && _f !== void 0 ? _f : '';
            var storageTravellersParsed = null;
            if (storageTravellers !== '') {
                storageTravellersParsed = JSON.parse(storageTravellers);
            }
            if (typeof storageTravellersParsed === 'object' && keepPreviousSearch) {
                var travellers = storageTravellersParsed;
                if (travellers) {
                    if (travellers.adults) {
                        numberOfAdults = travellers.adults;
                    }
                    if (travellers.children) {
                        delete productQuery['TRAVELLERS_CHILDREN_AGE'];
                        ageOfChildren = travellers.children;
                    }
                }
            }
            var travellersDefaultValue = {
                uiValue: InputValueMapper.getTravellersUIValue(numberOfAdults, ageOfChildren.length),
                value: {
                    adults: numberOfAdults,
                    ageOfChildren: ageOfChildren,
                    ageOfChildrenLength: ageOfChildren.length,
                    errorExists: false,
                    showError: false,
                    hasError: [],
                    childrenNoteShow: false,
                    groupTravelNoteShow: false,
                    childrenAgeChoiceShow: false
                },
            };
            var travellersConfirmedValue = JSON.parse(JSON.stringify(travellersDefaultValue));
            travellersConfirmedValue = UrlMapper.mapTravellers(travellersConfirmedValue, productQuery);
            var indexHotelCategory = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1200);
            var hotelCategoryOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelCategory].options));
            for (var hotelCategoryOptionsIndex = 0; hotelCategoryOptionsIndex < hotelCategoryOptions.length; hotelCategoryOptionsIndex++) {
                var option = hotelCategoryOptions[hotelCategoryOptionsIndex];
                if (option.queryParams.HOTEL_CATEGORY === void 0) {
                    option.value = null;
                }
                else {
                    option.value = option.queryParams.HOTEL_CATEGORY;
                }
                delete option.queryParams;
            }
            var defaultHotelCategory = {
                uiValue: {
                    text: Vue.translate('any'),
                    options: hotelCategoryOptions
                },
                value: null,
            };
            var confirmedHotelCategory = UrlMapper.mapHotelCategoryConfirmedValue(JSON.parse(JSON.stringify(defaultHotelCategory)), productQuery);
            var indexHotelBoardCodes = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1400);
            var hotelBoardCodesOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelBoardCodes].options));
            for (var hotelBoardCodesOptionsIndex = 0; hotelBoardCodesOptionsIndex < hotelBoardCodesOptions.length; hotelBoardCodesOptionsIndex++) {
                var option = hotelBoardCodesOptions[hotelBoardCodesOptionsIndex];
                if (!option.queryParams.HOTEL_BOARD_CODES) {
                    option.value = null;
                }
                else {
                    option.value = option.id;
                }
                delete option.queryParams;
            }
            var defaultHotelBoardCode = {
                uiValue: {
                    text: Vue.translate('any'),
                    options: hotelBoardCodesOptions
                },
                value: null,
            };
            var confirmedHotelBoardCode = UrlMapper.mapHotelBoardCodeConfirmedValue(defaultHotelBoardCode, productQuery);
            var defaultHotelRoomCode = {
                uiValue: null,
                value: null,
            };
            var confirmedHotelRoomCode = UrlMapper.mapHotelRoomCodeConfirmedValue(defaultHotelRoomCode, productQuery);
            var defaultHotelRecommendations = {
                uiValue: null,
                value: null,
            };
            var confirmedHotelRecommendations = UrlMapper.mapHotelRecommendationsConfirmedValue(defaultHotelRecommendations, productQuery);
            var defaultHotelRating = {
                uiValue: null,
                value: null,
            };
            var confirmedHotelRating = UrlMapper.mapHotelRatingConfirmedValue(defaultHotelRating, productQuery);
            var defaultLocation = {
                uiValue: null,
                value: null,
            };
            var confirmedLocation = UrlMapper.mapLocationConfirmedValue(defaultLocation, productQuery);
            var defaultFeatures = {
                uiValue: null,
                value: null,
            };
            var defaultOtherCodes = {
                uiValue: null,
                value: {}
            };
            var confirmedOtherCodes = UrlMapper.mapOtherCodesConfirmedValue(defaultOtherCodes, productQuery);
            var cmsTourOperatorCodes = settingsCMS.productSearch.productQuery.tourOperatorCodes;
            if (cmsTourOperatorCodes !== void 0 && cmsTourOperatorCodes.length > 0)
                confirmedOtherCodes.value.tourOperatorCodes = cmsTourOperatorCodes;
            var confirmedFeatures = UrlMapper.mapFeaturesConfirmedValue(defaultFeatures, productQuery);
            var defaultTargetGroups = {
                uiValue: null,
                value: null,
            };
            var confirmedTargetGroups = UrlMapper.mapTargetGroupsConfirmedValue(defaultTargetGroups, productQuery);
            var defaultSports = {
                uiValue: null,
                value: null,
            };
            var confirmedSports = UrlMapper.mapSportsConfirmedValue(defaultSports, productQuery);
            var defaultWintersports = {
                uiValue: null,
                value: null,
            };
            var confirmedWintersports = UrlMapper.mapWintersportsConfirmedValue(defaultWintersports, productQuery);
            var defaultWellness = {
                uiValue: null,
                value: null,
            };
            var confirmedWellness = UrlMapper.mapWellnessConfirmedValue(defaultWellness, productQuery);
            var defaultFamily = {
                uiValue: null,
                value: null,
            };
            var confirmedFamily = UrlMapper.mapFamilyConfirmedValue(defaultFamily, productQuery);
            var defaultRoomCharacteristics = {
                uiValue: null,
                value: null,
            };
            var confirmedRoomCharacteristics = UrlMapper.mapRoomCharacteristicsConfirmedValue(defaultRoomCharacteristics, productQuery);
            var defaultAccommodationTypeCode = {
                uiValue: null,
                value: null,
            };
            var confirmedAccommodationTypeCode = UrlMapper.mapAccommodationTypeCodeConfirmedValue(defaultAccommodationTypeCode, productQuery);
            var defaultDeals = {
                uiValue: null,
                value: null,
            };
            var confirmedDeals = UrlMapper.mapDealsConfirmedValue(defaultDeals, productQuery);
            var defaultTravelThemes = {
                uiValue: null,
                value: null,
            };
            var confirmedTravelThemes = UrlMapper.mapTravelThemesConfirmedValue(defaultTravelThemes, productQuery);
            var defaultFlightDepartureTimeRange = {
                uiValue: null,
                value: null,
            };
            var confirmedFlightDepartureTimeRange = UrlMapper.mapFlightDepartureTimeRangeConfirmedValue(defaultFlightDepartureTimeRange, productQuery);
            var defaultFlightReturnTimeRange = {
                uiValue: null,
                value: null,
            };
            var confirmedFlightReturnTimeRange = UrlMapper.mapFlightReturnTimeRangeConfirmedValue(defaultFlightDepartureTimeRange, productQuery);
            var defaultFlightStopOverMax = {
                uiValue: null,
                value: null,
            };
            var confirmedFlightStopOverMax = UrlMapper.mapFlightStopOverMaxConfirmedValue(defaultFlightDepartureTimeRange, productQuery);
            var defaultFlightIgnoreOpenJaw = {
                uiValue: null,
                value: null,
            };
            var confirmedFlightIgnoreOpenJaw = UrlMapper.mapFlightIgnoreOpenJawConfirmedValue(defaultFlightDepartureTimeRange, options);
            var defaultPriceRange = {
                uiValue: Vue.translate('any'),
                value: {
                    "priceMin": null,
                    "priceMax": null,
                    "currencySymbol": Currency.getSymbol(formData.context.currency),
                    "maxValue": 6000,
                    "minValue": 0,
                    "step": 100
                }
            };
            var confirmedPriceRange = UrlMapper.mapPriceRangeConfirmedValue(defaultPriceRange, productQuery);
            var defaultTransfer = {
                uiValue: null,
                value: false
            };
            var confirmedTransfer = UrlMapper.mapTransferConfirmedValue(defaultTransfer, productQuery);
            var defaultTrainToFlight = {
                uiValue: null,
                value: false
            };
            var confirmedTrainToFlight = UrlMapper.mapTrainToFlightConfirmedValue(defaultTransfer, productQuery);
            var defaultFlex = {
                uiValue: null,
                value: false
            };
            var confirmedFlex = UrlMapper.mapFlexConfirmedValue(defaultFlex, query);
            var defaultPagination = {
                uiValue: null,
                value: {
                    page: 0,
                    size: 10,
                    sorting: ['price']
                }
            };
            var confirmedPagination = UrlMapper.mapPaginationConfirmedValue(defaultPagination, query);
            _this.searchMaskGroups[SearchMaskGroupType.PACKAGE] = {
                inputs: (_a = {},
                    _a[SearchMaskInputType.DEPARTURE_AIRPORT] = {
                        defaultValue: JSON.parse(JSON.stringify(airportInitValue)),
                        confirmedValue: JSON.parse(JSON.stringify(airportInitValueConfirmedValue)),
                        modalIsInitialized: false,
                        type: SearchMaskInputType.DEPARTURE_AIRPORT,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(airportInitValueConfirmedValue, SearchMaskGroupType.PACKAGE, SearchMaskInputType.DEPARTURE_AIRPORT)
                    },
                    _a[SearchMaskInputType.DESTINATION] = {
                        confirmedValue: JSON.parse(JSON.stringify(UrlMapper.mapDestinationConfirmedValue(SearchMaskGroupType.PACKAGE, JSON.parse(JSON.stringify(destinationInitValue)), productQuery, productGroupId))),
                        defaultValue: JSON.parse(JSON.stringify(destinationInitValue)),
                        modalIsInitialized: false,
                        type: SearchMaskInputType.DESTINATION,
                        coreQuery: destinationCoreQuery,
                    },
                    _a[SearchMaskInputType.FEATURES] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFeatures)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFeatures)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FEATURES,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFeatures, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FEATURES)
                    },
                    _a[SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFlightDepartureTimeRange)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFlightDepartureTimeRange)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlightDepartureTimeRange, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE)
                    },
                    _a[SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFlightReturnTimeRange)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFlightReturnTimeRange)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlightReturnTimeRange, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE)
                    },
                    _a[SearchMaskInputType.FLIGHT_STOP_OVER_MAX] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFlightStopOverMax)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFlightStopOverMax)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FLIGHT_STOP_OVER_MAX,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlightStopOverMax, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_STOP_OVER_MAX)
                    },
                    _a[SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFlightIgnoreOpenJaw)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFlightIgnoreOpenJaw)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW,
                        coreOptions: UserInputValueToCoreMapper.mapOptions(confirmedFlightIgnoreOpenJaw, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW)
                    },
                    _a[SearchMaskInputType.HOTEL_CATEGORY] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultHotelCategory)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedHotelCategory)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.HOTEL_CATEGORY,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelCategory, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_CATEGORY)
                    },
                    _a[SearchMaskInputType.HOTEL_BOARD_CODES] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultHotelBoardCode)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedHotelBoardCode)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.HOTEL_BOARD_CODES,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelBoardCode, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_BOARD_CODES)
                    },
                    _a[SearchMaskInputType.HOTEL_ROOM_CODES] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultHotelRoomCode)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRoomCode)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.HOTEL_ROOM_CODES,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRoomCode, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_ROOM_CODES)
                    },
                    _a[SearchMaskInputType.HOTEL_RECOMMENDATIONS] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultHotelRecommendations)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRecommendations)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.HOTEL_RECOMMENDATIONS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRecommendations, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_RECOMMENDATIONS)
                    },
                    _a[SearchMaskInputType.HOTEL_RATING] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultHotelRating)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRating)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.HOTEL_RATING,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRating, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_RATING)
                    },
                    _a[SearchMaskInputType.LOCATION] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultLocation)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedLocation)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.LOCATION,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedLocation, SearchMaskGroupType.PACKAGE, SearchMaskInputType.LOCATION)
                    },
                    _a[SearchMaskInputType.OTHER_CODES] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultOtherCodes)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedOtherCodes)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.OTHER_CODES,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedOtherCodes, SearchMaskGroupType.PACKAGE, SearchMaskInputType.OTHER_CODES)
                    },
                    _a[SearchMaskInputType.SPORTS] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultSports)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedSports)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.SPORTS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedSports, SearchMaskGroupType.PACKAGE, SearchMaskInputType.SPORTS)
                    },
                    _a[SearchMaskInputType.WINTERSPORTS] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultWintersports)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedWintersports)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.WINTERSPORTS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedWintersports, SearchMaskGroupType.PACKAGE, SearchMaskInputType.WINTERSPORTS)
                    },
                    _a[SearchMaskInputType.WELLNESS] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultWellness)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedWellness)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.WELLNESS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedWellness, SearchMaskGroupType.PACKAGE, SearchMaskInputType.WELLNESS)
                    },
                    _a[SearchMaskInputType.ACCOMMODATION_TYPE_CODES] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultAccommodationTypeCode)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedAccommodationTypeCode)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.ACCOMMODATION_TYPE_CODES,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedAccommodationTypeCode, SearchMaskGroupType.PACKAGE, SearchMaskInputType.ACCOMMODATION_TYPE_CODES)
                    },
                    _a[SearchMaskInputType.FAMILY] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFamily)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFamily)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FAMILY,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFamily, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FAMILY)
                    },
                    _a[SearchMaskInputType.ROOMCHARACTERISTICS] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultRoomCharacteristics)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedRoomCharacteristics)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.ROOMCHARACTERISTICS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedRoomCharacteristics, SearchMaskGroupType.PACKAGE, SearchMaskInputType.ROOMCHARACTERISTICS)
                    },
                    _a[SearchMaskInputType.DEALS] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultDeals)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedDeals)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.DEALS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedDeals, SearchMaskGroupType.PACKAGE, SearchMaskInputType.DEALS)
                    },
                    _a[SearchMaskInputType.TRAVEL_THEMES] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultTravelThemes)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedTravelThemes)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.TRAVEL_THEMES,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTravelThemes, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAVEL_THEMES)
                    },
                    _a[SearchMaskInputType.PAGINATION] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultPagination)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedPagination)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.PAGINATION,
                    },
                    _a[SearchMaskInputType.PRICE_RANGE] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultPriceRange)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedPriceRange)),
                        modalIsInitialized: false,
                        type: SearchMaskInputType.PRICE_RANGE,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedPriceRange, SearchMaskGroupType.PACKAGE, SearchMaskInputType.PRICE_RANGE)
                    },
                    _a[SearchMaskInputType.TARGET_GROUPS] = {
                        confirmedValue: JSON.parse(JSON.stringify(confirmedTargetGroups)),
                        defaultValue: JSON.parse(JSON.stringify(defaultTargetGroups)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.TARGET_GROUPS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTargetGroups, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TARGET_GROUPS)
                    },
                    _a[SearchMaskInputType.TRAVEL_PERIOD] = {
                        confirmedValue: JSON.parse(JSON.stringify(travelPeriodConfirmedValue)),
                        defaultValue: JSON.parse(JSON.stringify(travelPeriodDefaultValue)),
                        modalIsInitialized: false,
                        type: SearchMaskInputType.TRAVEL_PERIOD,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(travelPeriodConfirmedValue, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAVEL_PERIOD)
                    },
                    _a[SearchMaskInputType.TRAVELLERS] = {
                        confirmedValue: JSON.parse(JSON.stringify(travellersConfirmedValue)),
                        defaultValue: JSON.parse(JSON.stringify(travellersDefaultValue)),
                        modalIsInitialized: false,
                        type: SearchMaskInputType.TRAVELLERS,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(travellersConfirmedValue, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAVELLERS),
                    },
                    _a[SearchMaskInputType.TRANSFER] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultTransfer)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedTransfer)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.TRANSFER,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTransfer, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRANSFER)
                    },
                    _a[SearchMaskInputType.TRAIN_TO_FLIGHT] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultTrainToFlight)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedTrainToFlight)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.TRAIN_TO_FLIGHT,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTrainToFlight, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAIN_TO_FLIGHT)
                    },
                    _a[SearchMaskInputType.FLEX] = {
                        defaultValue: JSON.parse(JSON.stringify(defaultFlex)),
                        confirmedValue: JSON.parse(JSON.stringify(confirmedFlex)),
                        modalIsInitialized: true,
                        type: SearchMaskInputType.FLEX,
                        coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlex, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLEX)
                    },
                    _a),
                initialized: true,
                type: SearchMaskGroupType.PACKAGE
            };
            if (typeof searchMaskBundle.groups[SearchMaskGroupType.HOTEL] === 'undefined') {
                searchMaskBundle.groups[SearchMaskGroupType.HOTEL] = {
                    inputs: {},
                    initialized: false,
                    type: SearchMaskGroupType.HOTEL
                };
            }
            if (typeof searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] === 'undefined') {
                searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] = {
                    inputs: {},
                    initialized: false,
                    type: SearchMaskGroupType.LAST_MINUTE
                };
            }
            if (typeof searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] === 'undefined') {
                searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] = {
                    inputs: {},
                    initialized: false,
                    type: SearchMaskGroupType.FLIGHT
                };
            }
            searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] = _this.searchMaskGroups[SearchMaskGroupType.PACKAGE];
            store.dispatch(websiteActions.setSearchMaskBundle(searchMaskBundle));
            searchMaskBundle.groups[SearchMaskGroupType.RAIL_PACKAGE] = null;
            store.dispatch(websiteActions.setSearchMaskBundle(searchMaskBundle));
            StateHelper.instance.resolveState(STATE.INPUT_VALUE_SETUP_PACKAGE);
        }, 0);
    };
    ;
    InputValueSetup.prototype.modifyReturnDateUsingDynamicDate = function (dynamicReturnDateDaysSetting, returnDateResult) {
        if (dynamicReturnDateDaysSetting != null) {
            var dynamicReturnDateDays = +dynamicReturnDateDaysSetting;
            var dateNow = new Date(Date.now() + 86400000 * dynamicReturnDateDays);
            returnDateResult = dateNow.toISOString().split('T')[0];
        }
        return returnDateResult;
    };
    InputValueSetup.prototype.modifyDepartureDateUsingDynamicDate = function (dynamicDepartureDateDaysSetting, departureDateResult) {
        if (dynamicDepartureDateDaysSetting != null) {
            var dynamicDepartureDateDays = +dynamicDepartureDateDaysSetting;
            var dateNow = new Date(Date.now() + 86400000 * dynamicDepartureDateDays);
            departureDateResult = dateNow.toISOString().split('T')[0];
        }
        return departureDateResult;
    };
    InputValueSetup.prototype.initializeHotel = function () {
        var _a;
        var _b, _c, _d, _e, _f;
        var state = store.getState();
        var formData = state.coreState.package.formData;
        var productQuery = state.websiteState.app.url.productQuery;
        var options = state.websiteState.app.url.productOptions;
        var query = state.websiteState.app.url.query;
        var productGroupId = state.websiteState.app.url.productGroupId;
        var productType = state.websiteState.app.url.context.productType;
        var settingsCMS = state.cmsState.api.response.settings;
        var keepPreviousSearch = (_b = settingsCMS.KeepSearchTab) !== null && _b !== void 0 ? _b : false;
        if (window.location.pathname.indexOf('de/hotel/weltweit') >= 0
            || window.location.pathname.indexOf('de/hotel/deutschland') >= 0) {
            keepPreviousSearch = true;
        }
        var searchMaskBundle = state.websiteState.searchMask.searchMaskBundle;
        if (!searchMaskBundle) {
            searchMaskBundle = this.searchMaskBundle;
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.HOTEL] !== 'undefined' && searchMaskBundle.groups[SearchMaskGroupType.HOTEL].initialized) {
            return;
        }
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
        productQuery = this.addSettingsCmsToProductQuery(formData, settingsCMS, productQuery);
        if (productGroupId === null && typeof settingsCMS.productGroups !== 'undefined' && settingsCMS.productGroups.length) {
            productGroupId = (settingsCMS.productGroups[0].id).toString();
        }
        var destinationInitValue = {
            uiValue: Vue.translate('any'),
            value: [],
        };
        var destinationCoreQuery = UrlMapper.mapDestinationCoreQuery(productQuery);
        var dynamicDepartureDateDaysSetting = (_c = settingsCMS.travelPeriodDepartureDateDynamicOffset) !== null && _c !== void 0 ? _c : null;
        var departureDateResult = formData.travelPeriod.departureDate.default;
        departureDateResult = this.modifyDepartureDateUsingDynamicDate(dynamicDepartureDateDaysSetting, departureDateResult);
        var dynamicReturnDateDaysSetting = (_d = settingsCMS.travelPeriodReturnDateDynamicOffset) !== null && _d !== void 0 ? _d : null;
        var returnDateResult = formData.travelPeriod.returnDate.default;
        returnDateResult = this.modifyReturnDateUsingDynamicDate(dynamicReturnDateDaysSetting, returnDateResult);
        var travelPeriodDefaultUIValue = __assign({}, Calendar.getTravelPeriodUIValue(departureDateResult, returnDateResult, false, false, false));
        var datePicker = (_e = sessionStorage.getItem('searchmask.datePicker')) !== null && _e !== void 0 ? _e : '';
        var datePickerParsed = null;
        if (datePicker !== '' && keepPreviousSearch) {
            datePickerParsed = JSON.parse(datePicker);
            returnDateResult = datePickerParsed.end;
            departureDateResult = datePickerParsed.start;
        }
        var travelPeriodDefaultValue = {
            uiValue: travelPeriodDefaultUIValue,
            value: {
                datePickerIsOpen: false,
                departureDate: departureDateResult,
                departureDateFull: departureDateResult,
                departureDateActive: false,
                exactDepartureDate: false,
                departureDays: [],
                duration: formData.travelPeriod.duration.default,
                exactDuration: false,
                returnDate: returnDateResult,
                returnDateFull: returnDateResult,
                triggerInitFlow: false,
                preferredDepartureDate: null
            }
        };
        var travelPeriodConfirmedValue = JSON.parse(JSON.stringify(travelPeriodDefaultValue));
        travelPeriodConfirmedValue.uiValue = UrlMapper.mapTravelPeriodUIValue(formData, travelPeriodDefaultUIValue, productQuery);
        travelPeriodConfirmedValue.value.departureDate = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDate, productQuery);
        travelPeriodConfirmedValue.value.departureDateFull = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDateFull, productQuery);
        // Setting departure date today without exactDeparture date is not permitted
        if (!travelPeriodConfirmedValue.value.exactDepartureDate &&
            new Date(travelPeriodConfirmedValue.value.departureDate).getTime() < new Date().setHours(24, 0, 0, 0)) {
            travelPeriodConfirmedValue.value.departureDate = format(addDays(new Date(), 1), 'YYYY-MM-DD');
            travelPeriodConfirmedValue.value.departureDateFull = format(addDays(new Date(), 1), 'YYYY-MM-DD');
        }
        travelPeriodConfirmedValue.value.departureDays = UrlMapper.mapTravelPeriodValueDepartureDays(travelPeriodDefaultValue.value.departureDays, productQuery);
        travelPeriodConfirmedValue.value.returnDate = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDate, productQuery);
        travelPeriodConfirmedValue.value.returnDateFull = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDateFull, productQuery);
        travelPeriodConfirmedValue.value.exactDuration = UrlMapper.mapTravelPeriodValueExactDuration(query, travelPeriodDefaultValue.value.exactDuration);
        travelPeriodConfirmedValue.value.preferredDepartureDate = UrlMapper.mapTravelPeriodValuePreferredDepartureDate(travelPeriodDefaultValue.value.preferredDepartureDate, productQuery);
        travelPeriodConfirmedValue.uiValue.duration =
            Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, settingsCMS.productSearch.productQuery.travelPeriodDuration);
        travelPeriodConfirmedValue.value.duration =
            UrlMapper.mapTravelPeriodValueDuration(settingsCMS.productSearch.productQuery.travelPeriodDuration, productQuery);
        if (typeof settingsCMS.travelPeriodDuration !== 'undefined') {
            travelPeriodConfirmedValue.uiValue.duration =
                Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, settingsCMS.productSearch.productQuery.travelPeriodDuration);
            travelPeriodConfirmedValue.value.duration =
                UrlMapper.mapTravelPeriodValueDuration(settingsCMS.productSearch.productQuery.travelPeriodDuration, productQuery);
        }
        travelPeriodConfirmedValue.uiValue.duration =
            UrlMapper.mapTravelPeriodUIValueDuration(formData, travelPeriodDefaultValue.uiValue.duration, productQuery);
        if (travelPeriodConfirmedValue.value.exactDuration) {
            var duration = differenceInDays(travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDate);
            if (duration > 28) {
                travelPeriodConfirmedValue.value.returnDate =
                    format(addDays(travelPeriodConfirmedValue.value.departureDate, 28), 'YYYY-MM-DD');
                duration = 28;
            }
            travelPeriodConfirmedValue.value.duration = Calendar.getDurationValue(duration);
            travelPeriodConfirmedValue.uiValue = Calendar.getTravelPeriodUIValue(travelPeriodConfirmedValue.value.departureDate, travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDateActive, travelPeriodConfirmedValue.value.returnDateActive, travelPeriodConfirmedValue.value.exactDuration);
            travelPeriodConfirmedValue.uiValue.duration = Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, travelPeriodConfirmedValue.value.duration);
        }
        var numberOfAdults = formData.travellers.adults.default;
        var ageOfChildren = formData.travellers.children.default;
        var storageTravellers = (_f = sessionStorage.getItem('searchmask.travellers')) !== null && _f !== void 0 ? _f : '';
        var storageTravellersParsed = null;
        if (storageTravellers !== '') {
            storageTravellersParsed = JSON.parse(storageTravellers);
        }
        if (typeof storageTravellersParsed === 'object' && keepPreviousSearch) {
            var travellers = storageTravellersParsed;
            if (travellers) {
                if (travellers.adults) {
                    numberOfAdults = travellers.adults;
                }
                if (travellers.children) {
                    delete productQuery['TRAVELLERS_CHILDREN_AGE'];
                    ageOfChildren = travellers.children;
                }
            }
        }
        var travellersDefaultValue = {
            uiValue: InputValueMapper.getTravellersUIValue(numberOfAdults, ageOfChildren.length),
            value: {
                adults: numberOfAdults,
                ageOfChildren: ageOfChildren,
                ageOfChildrenLength: ageOfChildren.length,
                errorExists: false,
                showError: false,
                hasError: [],
                childrenNoteShow: false,
                groupTravelNoteShow: false,
                childrenAgeChoiceShow: false
            },
        };
        var travellersConfirmedValue = JSON.parse(JSON.stringify(travellersDefaultValue));
        travellersConfirmedValue = UrlMapper.mapTravellers(travellersConfirmedValue, productQuery);
        var indexHotelCategory = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1200);
        var hotelCategoryOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelCategory].options));
        for (var hotelCategoryOptionsIndex = 0; hotelCategoryOptionsIndex < hotelCategoryOptions.length; hotelCategoryOptionsIndex++) {
            var option = hotelCategoryOptions[hotelCategoryOptionsIndex];
            if (option.queryParams.HOTEL_CATEGORY === void 0) {
                option.value = null;
            }
            else {
                option.value = option.queryParams.HOTEL_CATEGORY;
            }
            delete option.queryParams;
        }
        var defaultHotelCategory = {
            uiValue: {
                text: Vue.translate('any'),
                options: hotelCategoryOptions
            },
            value: null,
        };
        var confirmedHotelCategory = UrlMapper.mapHotelCategoryConfirmedValue(JSON.parse(JSON.stringify(defaultHotelCategory)), productQuery);
        var indexHotelBoardCodes = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1400);
        var hotelBoardCodesOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelBoardCodes].options));
        for (var hotelBoardCodesOptionsIndex = 0; hotelBoardCodesOptionsIndex < hotelBoardCodesOptions.length; hotelBoardCodesOptionsIndex++) {
            var option = hotelBoardCodesOptions[hotelBoardCodesOptionsIndex];
            if (!option.queryParams.HOTEL_BOARD_CODES) {
                option.value = null;
            }
            else {
                option.value = option.id;
            }
            delete option.queryParams;
        }
        var defaultHotelBoardCode = {
            uiValue: {
                text: Vue.translate('any'),
                options: hotelBoardCodesOptions
            },
            value: null,
        };
        var confirmedHotelBoardCode = UrlMapper.mapHotelBoardCodeConfirmedValue(defaultHotelBoardCode, productQuery);
        var defaultHotelRoomCode = {
            uiValue: null,
            value: null,
        };
        var confirmedHotelRoomCode = UrlMapper.mapHotelRoomCodeConfirmedValue(defaultHotelRoomCode, productQuery);
        var defaultHotelRecommendations = {
            uiValue: null,
            value: null,
        };
        var confirmedHotelRecommendations = UrlMapper.mapHotelRecommendationsConfirmedValue(defaultHotelRecommendations, productQuery);
        var defaultHotelRating = {
            uiValue: null,
            value: null,
        };
        var confirmedHotelRating = UrlMapper.mapHotelRatingConfirmedValue(defaultHotelRating, productQuery);
        var defaultLocation = {
            uiValue: null,
            value: null,
        };
        var confirmedLocation = UrlMapper.mapLocationConfirmedValue(defaultLocation, productQuery);
        var defaultFeatures = {
            uiValue: null,
            value: null,
        };
        var defaultOtherCodes = {
            uiValue: null,
            value: {}
        };
        delete productQuery['FLIGHT_AIRLINE_CODES'];
        var confirmedOtherCodes = UrlMapper.mapOtherCodesConfirmedValue(defaultOtherCodes, productQuery);
        var cmsTourOperatorCodes = settingsCMS.productSearch.productQuery.tourOperatorCodes;
        if (cmsTourOperatorCodes !== void 0 && cmsTourOperatorCodes.length > 0)
            confirmedOtherCodes.value.tourOperatorCodes = cmsTourOperatorCodes;
        var confirmedFeatures = UrlMapper.mapFeaturesConfirmedValue(defaultFeatures, productQuery);
        var defaultTargetGroups = {
            uiValue: null,
            value: null,
        };
        var confirmedTargetGroups = UrlMapper.mapTargetGroupsConfirmedValue(defaultTargetGroups, productQuery);
        var defaultSports = {
            uiValue: null,
            value: null,
        };
        var confirmedSports = UrlMapper.mapSportsConfirmedValue(defaultSports, productQuery);
        var defaultWinterports = {
            uiValue: null,
            value: null,
        };
        var confirmedWintersports = UrlMapper.mapWintersportsConfirmedValue(defaultWinterports, productQuery);
        var defaultWellness = {
            uiValue: null,
            value: null,
        };
        var confirmedWellness = UrlMapper.mapWellnessConfirmedValue(defaultWellness, productQuery);
        var defaultFamily = {
            uiValue: null,
            value: null,
        };
        var confirmedFamily = UrlMapper.mapFamilyConfirmedValue(defaultFamily, productQuery);
        var defaultRoomCharacteristics = {
            uiValue: null,
            value: null,
        };
        var confirmedRoomCharacteristics = UrlMapper.mapRoomCharacteristicsConfirmedValue(defaultRoomCharacteristics, productQuery);
        var defaultAccommodationTypeCode = {
            uiValue: null,
            value: null,
        };
        var confirmedAccommodationTypeCode = UrlMapper.mapAccommodationTypeCodeConfirmedValue(defaultAccommodationTypeCode, productQuery);
        var defaultDeals = {
            uiValue: null,
            value: null,
        };
        var confirmedDeals = UrlMapper.mapDealsConfirmedValue(defaultDeals, productQuery);
        var defaultTravelThemes = {
            uiValue: null,
            value: null,
        };
        var confirmedTravelThemes = UrlMapper.mapTravelThemesConfirmedValue(defaultTravelThemes, productQuery);
        var defaultPriceRange = {
            uiValue: Vue.translate('any'),
            value: {
                "priceMin": null,
                "priceMax": null,
                "currencySymbol": Currency.getSymbol(formData.context.currency),
                "maxValue": 6000,
                "minValue": 0,
                "step": 100
            }
        };
        var confirmedPriceRange = UrlMapper.mapPriceRangeConfirmedValue(defaultPriceRange, productQuery);
        var defaultFlex = {
            uiValue: null,
            value: false
        };
        var confirmedFlex = UrlMapper.mapFlexConfirmedValue(defaultFlex, query);
        var defaultPagination = {
            uiValue: null,
            value: {
                page: 0,
                size: 10,
                sorting: ['price']
            }
        };
        var confirmedPagination = UrlMapper.mapPaginationConfirmedValue(defaultPagination, query);
        this.searchMaskGroups[SearchMaskGroupType.HOTEL] = {
            inputs: (_a = {},
                _a[SearchMaskInputType.DESTINATION] = {
                    confirmedValue: JSON.parse(JSON.stringify(UrlMapper.mapDestinationConfirmedValue(SearchMaskGroupType.HOTEL, JSON.parse(JSON.stringify(destinationInitValue)), productQuery, productGroupId))),
                    defaultValue: JSON.parse(JSON.stringify(destinationInitValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.DESTINATION,
                    coreQuery: destinationCoreQuery,
                },
                _a[SearchMaskInputType.FEATURES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFeatures)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFeatures)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FEATURES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFeatures, SearchMaskGroupType.HOTEL, SearchMaskInputType.FEATURES)
                },
                _a[SearchMaskInputType.HOTEL_CATEGORY] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelCategory)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelCategory)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_CATEGORY,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelCategory, SearchMaskGroupType.HOTEL, SearchMaskInputType.HOTEL_CATEGORY)
                },
                _a[SearchMaskInputType.HOTEL_BOARD_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelBoardCode)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelBoardCode)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_BOARD_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelBoardCode, SearchMaskGroupType.HOTEL, SearchMaskInputType.HOTEL_BOARD_CODES)
                },
                _a[SearchMaskInputType.HOTEL_ROOM_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelRoomCode)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRoomCode)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_ROOM_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRoomCode, SearchMaskGroupType.HOTEL, SearchMaskInputType.HOTEL_ROOM_CODES)
                },
                _a[SearchMaskInputType.HOTEL_RECOMMENDATIONS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelRecommendations)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRecommendations)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_RECOMMENDATIONS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRecommendations, SearchMaskGroupType.HOTEL, SearchMaskInputType.HOTEL_RECOMMENDATIONS)
                },
                _a[SearchMaskInputType.HOTEL_RATING] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelRating)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRating)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_RATING,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRating, SearchMaskGroupType.HOTEL, SearchMaskInputType.HOTEL_RATING)
                },
                _a[SearchMaskInputType.LOCATION] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultLocation)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedLocation)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.LOCATION,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedLocation, SearchMaskGroupType.HOTEL, SearchMaskInputType.LOCATION)
                },
                _a[SearchMaskInputType.OTHER_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultOtherCodes)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedOtherCodes)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.OTHER_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedOtherCodes, SearchMaskGroupType.HOTEL, SearchMaskInputType.OTHER_CODES)
                },
                _a[SearchMaskInputType.SPORTS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultSports)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedSports)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.SPORTS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedSports, SearchMaskGroupType.HOTEL, SearchMaskInputType.SPORTS)
                },
                _a[SearchMaskInputType.WINTERSPORTS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultWinterports)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedWintersports)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.WINTERSPORTS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedWintersports, SearchMaskGroupType.HOTEL, SearchMaskInputType.WINTERSPORTS)
                },
                _a[SearchMaskInputType.WELLNESS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultWellness)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedWellness)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.WELLNESS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedWellness, SearchMaskGroupType.HOTEL, SearchMaskInputType.WELLNESS)
                },
                _a[SearchMaskInputType.ACCOMMODATION_TYPE_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultAccommodationTypeCode)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedAccommodationTypeCode)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.ACCOMMODATION_TYPE_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedAccommodationTypeCode, SearchMaskGroupType.HOTEL, SearchMaskInputType.ACCOMMODATION_TYPE_CODES)
                },
                _a[SearchMaskInputType.FAMILY] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFamily)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFamily)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FAMILY,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFamily, SearchMaskGroupType.HOTEL, SearchMaskInputType.FAMILY)
                },
                _a[SearchMaskInputType.ROOMCHARACTERISTICS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultRoomCharacteristics)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedRoomCharacteristics)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.ROOMCHARACTERISTICS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedRoomCharacteristics, SearchMaskGroupType.HOTEL, SearchMaskInputType.ROOMCHARACTERISTICS)
                },
                _a[SearchMaskInputType.DEALS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultDeals)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedDeals)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.DEALS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedDeals, SearchMaskGroupType.HOTEL, SearchMaskInputType.DEALS)
                },
                _a[SearchMaskInputType.TRAVEL_THEMES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultTravelThemes)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedTravelThemes)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.TRAVEL_THEMES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTravelThemes, SearchMaskGroupType.HOTEL, SearchMaskInputType.TRAVEL_THEMES)
                },
                _a[SearchMaskInputType.PAGINATION] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultPagination)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedPagination)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.PAGINATION,
                },
                _a[SearchMaskInputType.PRICE_RANGE] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultPriceRange)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedPriceRange)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.PRICE_RANGE,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedPriceRange, SearchMaskGroupType.HOTEL, SearchMaskInputType.PRICE_RANGE)
                },
                _a[SearchMaskInputType.TARGET_GROUPS] = {
                    confirmedValue: JSON.parse(JSON.stringify(confirmedTargetGroups)),
                    defaultValue: JSON.parse(JSON.stringify(defaultTargetGroups)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.TARGET_GROUPS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTargetGroups, SearchMaskGroupType.HOTEL, SearchMaskInputType.TARGET_GROUPS)
                },
                _a[SearchMaskInputType.TRAVEL_PERIOD] = {
                    confirmedValue: JSON.parse(JSON.stringify(travelPeriodConfirmedValue)),
                    defaultValue: JSON.parse(JSON.stringify(travelPeriodDefaultValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.TRAVEL_PERIOD,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(travelPeriodConfirmedValue, SearchMaskGroupType.HOTEL, SearchMaskInputType.TRAVEL_PERIOD)
                },
                _a[SearchMaskInputType.TRAVELLERS] = {
                    confirmedValue: JSON.parse(JSON.stringify(travellersConfirmedValue)),
                    defaultValue: JSON.parse(JSON.stringify(travellersDefaultValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.TRAVELLERS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(travellersConfirmedValue, SearchMaskGroupType.HOTEL, SearchMaskInputType.TRAVELLERS),
                },
                _a[SearchMaskInputType.FLEX] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFlex)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFlex)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FLEX,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlex, SearchMaskGroupType.HOTEL, SearchMaskInputType.FLEX)
                },
                _a),
            initialized: true,
            type: SearchMaskGroupType.HOTEL
        };
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.PACKAGE
            };
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.LAST_MINUTE
            };
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.FLIGHT
            };
        }
        searchMaskBundle.groups[SearchMaskGroupType.HOTEL] = this.searchMaskGroups[SearchMaskGroupType.HOTEL];
        store.dispatch(websiteActions.setSearchMaskBundle(searchMaskBundle));
    };
    InputValueSetup.prototype.initializeLastMinute = function () {
        var _a;
        var _b, _c;
        var state = store.getState();
        var formData = state.coreState.package.formData;
        var productQuery = state.websiteState.app.url.productQuery;
        var options = state.websiteState.app.url.productOptions;
        var query = state.websiteState.app.url.query;
        var productGroupId = state.websiteState.app.url.productGroupId;
        var productType = state.websiteState.app.url.context.productType;
        var settingsCMS = state.cmsState.api.response.settings;
        var keepPreviousSearch = (_b = settingsCMS.KeepSearchTab) !== null && _b !== void 0 ? _b : false;
        var searchMaskBundle = state.websiteState.searchMask.searchMaskBundle;
        if (!searchMaskBundle) {
            searchMaskBundle = this.searchMaskBundle;
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] !== 'undefined' && searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE].initialized) {
            return;
        }
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
        Vue.dispatch(websiteActions.setActiveTabSearchMask(searchMaskGroupType));
        var airportInitValue = {
            uiValue: Vue.translate('any'),
            value: [],
        };
        var destinationInitValue = {
            uiValue: Vue.translate('any'),
            value: [],
        };
        var destinationCoreQuery = UrlMapper.mapDestinationCoreQuery(productQuery);
        var travelPeriodDefaultUIValue = __assign({}, Calendar.getTravelPeriodUIValue(formData.travelPeriod.departureDate.default, formData.travelPeriod.returnDate.default, false, false, false));
        var travelPeriodDefaultValue = {
            uiValue: travelPeriodDefaultUIValue,
            value: {
                datePickerIsOpen: false,
                departureDate: formData.travelPeriod.departureDate.default,
                departureDateFull: formData.travelPeriod.departureDate.default,
                departureDateActive: false,
                departureDays: [],
                duration: formData.travelPeriod.duration.default,
                exactDuration: false,
                returnDate: formData.travelPeriod.returnDate.default,
                returnDateFull: formData.travelPeriod.returnDate.default,
                returnDateActive: false,
                triggerInitFlow: false,
                preferredDepartureDate: null
            }
        };
        var travelPeriodConfirmedValue = JSON.parse(JSON.stringify(travelPeriodDefaultValue));
        travelPeriodConfirmedValue.uiValue = UrlMapper.mapTravelPeriodUIValue(formData, travelPeriodDefaultUIValue, productQuery);
        travelPeriodConfirmedValue.value.departureDate = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDate, productQuery);
        travelPeriodConfirmedValue.value.departureDateFull = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDateFull, productQuery);
        travelPeriodConfirmedValue.value.departureDays = UrlMapper.mapTravelPeriodValueDepartureDays(travelPeriodDefaultValue.value.departureDays, productQuery);
        travelPeriodConfirmedValue.value.returnDate = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDate, productQuery);
        travelPeriodConfirmedValue.value.returnDateFull = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDateFull, productQuery);
        travelPeriodConfirmedValue.value.exactDuration = UrlMapper.mapTravelPeriodValueExactDuration(query, travelPeriodDefaultValue.value.exactDuration);
        travelPeriodConfirmedValue.value.preferredDepartureDate = UrlMapper.mapTravelPeriodValuePreferredDepartureDate(travelPeriodDefaultValue.value.preferredDepartureDate, query);
        travelPeriodConfirmedValue.uiValue.duration =
            Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, settingsCMS.productSearch.productQuery.travelPeriodDuration);
        travelPeriodConfirmedValue.value.duration =
            UrlMapper.mapTravelPeriodValueDuration(settingsCMS.productSearch.productQuery.travelPeriodDuration, productQuery);
        travelPeriodConfirmedValue.uiValue.duration =
            UrlMapper.mapTravelPeriodUIValueDuration(formData, travelPeriodDefaultValue.uiValue.duration, productQuery);
        if (travelPeriodConfirmedValue.value.exactDuration) {
            var duration = differenceInDays(travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDate);
            if (duration > 28) {
                travelPeriodConfirmedValue.value.returnDate =
                    format(addDays(travelPeriodConfirmedValue.value.departureDate, 28), 'YYYY-MM-DD');
                duration = 28;
            }
            travelPeriodConfirmedValue.value.duration = Calendar.getDurationValue(duration);
            travelPeriodConfirmedValue.uiValue.duration = Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, travelPeriodConfirmedValue.value.duration);
            travelPeriodConfirmedValue.uiValue = Calendar.getTravelPeriodUIValue(travelPeriodConfirmedValue.value.departureDate, travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDateActive, travelPeriodConfirmedValue.value.returnDateActive, travelPeriodConfirmedValue.value.exactDuration);
        }
        var numberOfAdults = formData.travellers.adults.default;
        var ageOfChildren = formData.travellers.children.default;
        var storageTravellers = (_c = sessionStorage.getItem('searchmask.travellers')) !== null && _c !== void 0 ? _c : '';
        var storageTravellersParsed = null;
        if (storageTravellers !== '') {
            storageTravellersParsed = JSON.parse(storageTravellers);
        }
        if (typeof storageTravellersParsed === 'object' && keepPreviousSearch) {
            var travellers = storageTravellersParsed;
            if (travellers) {
                if (travellers.adults) {
                    numberOfAdults = travellers.adults;
                }
                if (travellers.children) {
                    delete productQuery['TRAVELLERS_CHILDREN_AGE'];
                    ageOfChildren = travellers.children;
                }
            }
        }
        var travellersDefaultValue = {
            uiValue: InputValueMapper.getTravellersUIValue(numberOfAdults, ageOfChildren.length),
            value: {
                adults: numberOfAdults,
                ageOfChildren: ageOfChildren,
                ageOfChildrenLength: ageOfChildren.length,
                errorExists: false,
                showError: false,
                hasError: [],
                childrenNoteShow: false,
                groupTravelNoteShow: false,
                childrenAgeChoiceShow: false
            },
        };
        var indexHotelCategory = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1200);
        var hotelCategoryOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelCategory].options));
        for (var hotelCategoryOptionsIndex = 0; hotelCategoryOptionsIndex < hotelCategoryOptions.length; hotelCategoryOptionsIndex++) {
            var option = hotelCategoryOptions[hotelCategoryOptionsIndex];
            if (option.queryParams.HOTEL_CATEGORY === void 0) {
                option.value = null;
            }
            else {
                option.value = option.queryParams.HOTEL_CATEGORY;
            }
            delete option.queryParams;
        }
        var indexHotelBoardCodes = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1400);
        var hotelBoardCodesOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelBoardCodes].options));
        for (var hotelBoardCodesOptionsIndex = 0; hotelBoardCodesOptionsIndex < hotelBoardCodesOptions.length; hotelBoardCodesOptionsIndex++) {
            var option = hotelBoardCodesOptions[hotelBoardCodesOptionsIndex];
            if (!option.queryParams.HOTEL_BOARD_CODES) {
                option.value = null;
            }
            else {
                option.value = option.id;
            }
            delete option.queryParams;
        }
        this.searchMaskGroups[SearchMaskGroupType.LAST_MINUTE] = {
            type: SearchMaskGroupType.LAST_MINUTE,
            initialized: true,
            inputs: (_a = {},
                _a[SearchMaskInputType.DEPARTURE_AIRPORT] = {
                    type: SearchMaskInputType.DEPARTURE_AIRPORT,
                    defaultValue: JSON.parse(JSON.stringify(airportInitValue)),
                    confirmedValue: JSON.parse(JSON.stringify(airportInitValue)),
                    modalIsInitialized: false,
                },
                _a[SearchMaskInputType.DESTINATION] = {
                    confirmedValue: JSON.parse(JSON.stringify(destinationInitValue)),
                    defaultValue: JSON.parse(JSON.stringify(destinationInitValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.DESTINATION,
                    coreQuery: destinationCoreQuery,
                },
                _a[SearchMaskInputType.TRAVEL_PERIOD] = {
                    confirmedValue: JSON.parse(JSON.stringify(travelPeriodDefaultValue)),
                    defaultValue: JSON.parse(JSON.stringify(travelPeriodDefaultValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.TRAVEL_PERIOD,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(travelPeriodConfirmedValue, SearchMaskGroupType.LAST_MINUTE, SearchMaskInputType.TRAVEL_PERIOD)
                },
                _a),
        };
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.PACKAGE
            };
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.HOTEL] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.HOTEL] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.HOTEL
            };
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.FLIGHT
            };
        }
        searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] = this.searchMaskGroups[SearchMaskGroupType.LAST_MINUTE];
        store.dispatch(websiteActions.setSearchMaskBundle(searchMaskBundle));
    };
    ;
    InputValueSetup.prototype.urlIsLastMinute = function () {
        return window.location.pathname.indexOf('reisearten/last-minute') >= 0
            || window.location.pathname.indexOf('reisearten/super-last-minute') >= 0
            || window.location.pathname.indexOf('typesdevoyages/derniereminute') >= 0
            || window.location.pathname.indexOf('typesdevoyages/super-derniere-minute') >= 0;
    };
    InputValueSetup.prototype.addSettingsCmsToProductQuery = function (formData, settingsCMS, productQuery) {
        var _a;
        var boardCodeIdCMS = null;
        if (typeof settingsCMS.productSearch.productQuery.hotelBoardCodes !== 'undefined') {
            var boardCodes = settingsCMS.productSearch.productQuery.hotelBoardCodes;
            var boardCode_1 = boardCodes[0].split(' ')[0];
            var optionsFormData = getOptionsFromFormData(1400);
            optionsFormData.forEach(function (item) {
                if (typeof item.queryParams['HOTEL_BOARD_CODES'] !== 'undefined') {
                    var boardCodeQueryParams = item.queryParams['HOTEL_BOARD_CODES'];
                    var boardCodeQueryParam = boardCodeQueryParams[0].split(' ')[0];
                    if (boardCodeQueryParam === boardCode_1) {
                        boardCodeIdCMS = item.id;
                    }
                }
            });
        }
        var roomCode = null;
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.hotelRoomCodes !== 'undefined'
            && settingsCMS.productSearch.productQuery.hotelRoomCodes.length) {
            var roomCodeAttribute_1 = settingsCMS.productSearch.productQuery.hotelRoomCodes[0];
            var optionsFormData = getOptionsFromFormData(1300);
            optionsFormData.forEach(function (item) {
                if (typeof item.queryParams['HOTEL_ROOM_CODES'] !== 'undefined') {
                    var roomCodeQueryParam = item.queryParams['HOTEL_ROOM_CODES'][0];
                    if (roomCodeQueryParam === roomCodeAttribute_1) {
                        roomCode = item.id;
                    }
                }
            });
        }
        var roomViewCode = null;
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.hotelRoomViewCodes !== 'undefined'
            && settingsCMS.productSearch.productQuery.hotelRoomViewCodes.length) {
            var roomViewCodeAttribute_1 = settingsCMS.productSearch.productQuery.hotelRoomViewCodes[0];
            var optionsFormData = getOptionsFromFormData(1600);
            optionsFormData.forEach(function (item) {
                if (typeof item.queryParams['HOTEL_ROOM_VIEW_CODES'] !== 'undefined') {
                    var roomViewCodeQueryParam = item.queryParams['HOTEL_ROOM_VIEW_CODES'][0];
                    if (roomViewCodeQueryParam === roomViewCodeAttribute_1) {
                        roomViewCode = item.id;
                    }
                }
            });
        }
        var recommandationsTotal = null;
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.hotelRecommendationsTotal !== 'undefined') {
            var recommandationsTotalAttribute_1 = settingsCMS.productSearch.productQuery.hotelRecommendationsTotal;
            var optionsFormData = getOptionsFromFormData(1800);
            optionsFormData.forEach(function (item) {
                if (typeof item.queryParams['HOTEL_RECOMMENDATIONS_TOTAL'] !== 'undefined') {
                    var recommandationsTotalQueryParam = item.queryParams['HOTEL_RECOMMENDATIONS_TOTAL'];
                    if (recommandationsTotalQueryParam === recommandationsTotalAttribute_1) {
                        recommandationsTotal = item.id;
                    }
                }
            });
        }
        var ratingOverAll = null;
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.hotelRatingOverAll !== 'undefined') {
            var ratingOverAllAttribute_1 = settingsCMS.productSearch.productQuery.hotelRatingOverAll;
            var optionsFormData = getOptionsFromFormData(1900);
            optionsFormData.forEach(function (item) {
                if (typeof item.queryParams['HOTEL_RATING_OVERALL'] !== 'undefined') {
                    var ratingOverAllQueryParam = item.queryParams['HOTEL_RATING_OVERALL'];
                    if (ratingOverAllQueryParam === ratingOverAllAttribute_1) {
                        ratingOverAll = item.id;
                    }
                }
            });
        }
        var hotelAttributes = [];
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.hotelAttributes !== 'undefined') {
            var cmsHotelAttributes = settingsCMS.productSearch.productQuery.hotelAttributes;
            cmsHotelAttributes.forEach(function (attribute) {
                if (attribute !== "") {
                    hotelAttributes.push(attribute);
                }
            });
        }
        if (typeof productQuery['PRICE_MIN'] === 'undefined'
            && typeof settingsCMS.productSearch.productQuery['minPrice'] !== 'undefined') {
            productQuery['PRICE_MIN'] = settingsCMS.productSearch.productQuery['minPrice'];
        }
        if (typeof productQuery['PRICE_MAX'] === 'undefined'
            && typeof settingsCMS.productSearch.productQuery['maxPrice'] !== 'undefined') {
            productQuery['PRICE_MAX'] = settingsCMS.productSearch.productQuery['maxPrice'];
        }
        if (typeof productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'] === 'undefined'
            && typeof settingsCMS.travelPeriodDepartureDate !== 'undefined') {
            productQuery['TRAVEL_PERIOD_DEPARTURE_DATE'] = format(new Date(settingsCMS.travelPeriodDepartureDate.timestamp * 1000), 'YYYY-MM-DD');
        }
        if (typeof productQuery['TRAVEL_PERIOD_RETURN_DATE'] === 'undefined'
            && typeof settingsCMS.travelPeriodReturnDate !== 'undefined') {
            productQuery['TRAVEL_PERIOD_RETURN_DATE'] = format(new Date(settingsCMS.travelPeriodReturnDate.timestamp * 1000), 'YYYY-MM-DD');
        }
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.travelPeriodDuration !== 'undefined'
            && productQuery['TRAVEL_PERIOD_DURATION'] === formData.travelPeriod.duration.default) {
            productQuery['TRAVEL_PERIOD_DURATION'] = settingsCMS.productSearch.productQuery.travelPeriodDuration;
        }
        if (typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.travellersAdults !== 'undefined'
            && productQuery['TRAVELLERS_ADULTS'] === formData.travellers.adults.default) {
            productQuery['TRAVELLERS_ADULTS'] = settingsCMS.productSearch.productQuery.travellersAdults;
        }
        if (typeof productQuery['TRAVELLERS_CHILDREN_AGE'] === 'undefined'
            && typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.travellersChildrenAge !== 'undefined') {
            productQuery['TRAVELLERS_CHILDREN_AGE'] = settingsCMS.productSearch.productQuery.travellersChildrenAge;
        }
        if (typeof productQuery['HOTEL_CATEGORY'] === 'undefined'
            && typeof settingsCMS.productSearch !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery !== 'undefined'
            && typeof settingsCMS.productSearch.productQuery.hotelCategory !== 'undefined') {
            productQuery['HOTEL_CATEGORY'] = settingsCMS.productSearch.productQuery.hotelCategory;
        }
        if (boardCodeIdCMS !== null) {
            if (typeof productQuery['OPTIONS'] === 'undefined') {
                productQuery['OPTIONS'] = [];
            }
            productQuery['OPTIONS'].push(boardCodeIdCMS);
        }
        if (roomCode !== null) {
            if (typeof productQuery['OPTIONS'] === 'undefined') {
                productQuery['OPTIONS'] = [];
            }
            productQuery['OPTIONS'].push(roomCode);
        }
        if (roomViewCode !== null) {
            if (typeof productQuery['OPTIONS'] === 'undefined') {
                productQuery['OPTIONS'] = [];
            }
            productQuery['OPTIONS'].push(roomViewCode);
        }
        if (recommandationsTotal !== null) {
            if (typeof productQuery['OPTIONS'] === 'undefined') {
                productQuery['OPTIONS'] = [];
            }
            productQuery['OPTIONS'].push(recommandationsTotal);
        }
        if (ratingOverAll !== null) {
            if (typeof productQuery['OPTIONS'] === 'undefined') {
                productQuery['OPTIONS'] = [];
            }
            productQuery['OPTIONS'].push(ratingOverAll);
        }
        if (hotelAttributes.length) {
            if (typeof productQuery['OPTIONS'] === 'undefined') {
                productQuery['OPTIONS'] = [];
            }
            (_a = productQuery['OPTIONS']).push.apply(_a, __spreadArray([], __read(hotelAttributes), false));
        }
        return productQuery;
    };
    InputValueSetup.prototype.initializeBookmark = function () {
        var _a;
        var _b, _c, _d;
        var state = store.getState();
        var formData = state.coreState.package.formData;
        var productQuery = state.websiteState.app.url.productQuery;
        var options = state.websiteState.app.url.productOptions;
        var query = state.websiteState.app.url.query;
        var productGroupId = state.websiteState.app.url.productGroupId;
        var productType = state.websiteState.app.url.context.productType;
        var settingsCMS = state.cmsState.api.response.settings;
        var keepPreviousSearch = (_b = settingsCMS.KeepSearchTab) !== null && _b !== void 0 ? _b : false;
        var searchMaskBundle = state.websiteState.searchMask.searchMaskBundle;
        if (!searchMaskBundle) {
            searchMaskBundle = this.searchMaskBundle;
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] !== 'undefined' && searchMaskBundle.groups[SearchMaskGroupType.PACKAGE].initialized) {
            return;
        }
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
        if (searchMaskGroupType === 'HOTEL') {
            this.initializeHotel();
        }
        Vue.dispatch(websiteActions.setActiveTabSearchMask(searchMaskGroupType));
        var airportInitValue = {
            uiValue: Vue.translate('any'),
            value: [],
        };
        var departureAirport = (_c = sessionStorage.getItem('searchmask.departureAirport')) !== null && _c !== void 0 ? _c : '';
        var airportCodes = [];
        if (keepPreviousSearch && departureAirport !== '') {
            var departureAirportParsed = JSON.parse(departureAirport);
            departureAirportParsed.forEach(function (element) {
                airportCodes.push(element.code);
            });
        }
        if (typeof productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] === 'undefined'
            && typeof settingsCMS.productSearch.productQuery['flightDepartureAirportCodes'] !== 'undefined') {
            productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] = settingsCMS.productSearch.productQuery['flightDepartureAirportCodes'];
        }
        if (airportCodes.length > 0 && keepPreviousSearch) {
            productQuery['FLIGHT_DEPARTURE_AIRPORT_CODES'] = airportCodes;
        }
        if (typeof productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS'] === 'undefined'
            && typeof settingsCMS.productSearch.productQuery['flightDepartureAirportGroups'] !== 'undefined') {
            productQuery['FLIGHT_DEPARTURE_AIRPORT_GROUPS'] = settingsCMS.productSearch.productQuery['flightDepartureAirportGroups'];
        }
        productQuery = this.addSettingsCmsToProductQuery(formData, settingsCMS, productQuery);
        if (productGroupId === null && typeof settingsCMS.productGroups !== 'undefined' && settingsCMS.productGroups.length) {
            productGroupId = (settingsCMS.productGroups[0].id).toString();
        }
        var airportInitValueConfirmedValue = UrlMapper.mapDepartureAirport(formData.departureAirportGroups, JSON.parse(JSON.stringify(airportInitValue)), searchMaskGroupType, productQuery);
        var destinationInitValue = {
            uiValue: Vue.translate('any'),
            value: [],
        };
        var destinationCoreQuery = UrlMapper.mapDestinationCoreQuery(productQuery);
        var travelPeriodDefaultUIValue = __assign({}, Calendar.getTravelPeriodUIValue(formData.travelPeriod.departureDate.default, formData.travelPeriod.returnDate.default, false, false, false));
        var travelPeriodDefaultValue = {
            uiValue: travelPeriodDefaultUIValue,
            value: {
                datePickerIsOpen: false,
                departureDate: "",
                departureDateFull: "",
                departureDateActive: false,
                departureDays: [],
                duration: 10000,
                exactDuration: false,
                returnDate: "",
                returnDateFull: "",
                returnDateActive: false,
                triggerInitFlow: false,
                preferredDepartureDate: null
            }
        };
        var travelPeriodConfirmedValue = JSON.parse(JSON.stringify(travelPeriodDefaultValue));
        travelPeriodConfirmedValue.uiValue = UrlMapper.mapTravelPeriodUIValue(formData, travelPeriodDefaultUIValue, productQuery);
        // travelPeriodConfirmedValue.value.departureDate = "2022-04-04";
        travelPeriodConfirmedValue.value.departureDate = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDate, productQuery);
        // travelPeriodConfirmedValue.value.departureDateFull = "2022-04-04";
        travelPeriodConfirmedValue.value.departureDateFull = UrlMapper.mapTravelPeriodValueDepartureDate(travelPeriodDefaultValue.value.departureDateFull, productQuery);
        travelPeriodConfirmedValue.value.departureDays = UrlMapper.mapTravelPeriodValueDepartureDays(travelPeriodDefaultValue.value.departureDays, productQuery);
        travelPeriodConfirmedValue.value.returnDate = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDate, productQuery);
        travelPeriodConfirmedValue.value.returnDateFull = UrlMapper.mapTravelPeriodValueReturnDate(travelPeriodDefaultValue.value.returnDateFull, productQuery);
        travelPeriodConfirmedValue.value.exactDuration = UrlMapper.mapTravelPeriodValueExactDuration(query, travelPeriodDefaultValue.value.exactDuration);
        travelPeriodConfirmedValue.value.preferredDepartureDate = UrlMapper.mapTravelPeriodValuePreferredDepartureDate(travelPeriodDefaultValue.value.preferredDepartureDate, query);
        travelPeriodConfirmedValue.uiValue.duration =
            Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, formData.travelPeriod.duration.default);
        travelPeriodConfirmedValue.value.duration =
            UrlMapper.mapTravelPeriodValueDuration(travelPeriodDefaultValue.value.duration, productQuery);
        if (typeof settingsCMS.travelPeriodDuration !== 'undefined') {
            travelPeriodConfirmedValue.uiValue.duration =
                Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, settingsCMS.productSearch.productQuery.travelPeriodDuration);
            travelPeriodConfirmedValue.value.duration =
                UrlMapper.mapTravelPeriodValueDuration(settingsCMS.productSearch.productQuery.travelPeriodDuration, productQuery);
        }
        travelPeriodConfirmedValue.uiValue.duration =
            UrlMapper.mapTravelPeriodUIValueDuration(formData, travelPeriodDefaultValue.uiValue.duration, productQuery);
        if (travelPeriodConfirmedValue.value.exactDuration) {
            var duration = differenceInDays(travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDate);
            if (duration > 28) {
                travelPeriodConfirmedValue.value.returnDate =
                    format(addDays(travelPeriodConfirmedValue.value.departureDate, 28), 'YYYY-MM-DD');
                duration = 28;
            }
            travelPeriodConfirmedValue.value.duration = Calendar.getDurationValue(duration);
            travelPeriodConfirmedValue.uiValue = Calendar.getTravelPeriodUIValue(travelPeriodConfirmedValue.value.departureDate, travelPeriodConfirmedValue.value.returnDate, travelPeriodConfirmedValue.value.departureDateActive, travelPeriodConfirmedValue.value.returnDateActive, travelPeriodConfirmedValue.value.exactDuration);
            travelPeriodConfirmedValue.uiValue.duration = Calendar.getTravelPeriodUIValueDuration(formData.travelPeriod.duration.values, travelPeriodConfirmedValue.value.duration);
        }
        var numberOfAdults = formData.travellers.adults.default;
        var ageOfChildren = formData.travellers.children.default;
        var storageTravellers = (_d = sessionStorage.getItem('searchmask.travellers')) !== null && _d !== void 0 ? _d : '';
        var storageTravellersParsed = null;
        if (storageTravellers !== '') {
            storageTravellersParsed = JSON.parse(storageTravellers);
        }
        if (typeof storageTravellersParsed === 'object' && keepPreviousSearch) {
            var travellers = storageTravellersParsed;
            if (travellers) {
                if (travellers.adults) {
                    numberOfAdults = travellers.adults;
                }
                if (travellers.children) {
                    delete productQuery['TRAVELLERS_CHILDREN_AGE'];
                    ageOfChildren = travellers.children;
                }
            }
        }
        var travellersDefaultValue = {
            uiValue: InputValueMapper.getTravellersUIValue(numberOfAdults, ageOfChildren.length),
            value: {
                adults: numberOfAdults,
                ageOfChildren: ageOfChildren,
                ageOfChildrenLength: ageOfChildren.length,
                errorExists: false,
                showError: false,
                hasError: [],
                childrenNoteShow: false,
                groupTravelNoteShow: false,
                childrenAgeChoiceShow: false
            },
        };
        var travellersConfirmedValue = JSON.parse(JSON.stringify(travellersDefaultValue));
        travellersConfirmedValue = UrlMapper.mapTravellers(travellersConfirmedValue, productQuery);
        var indexHotelCategory = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1200);
        var hotelCategoryOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelCategory].options));
        for (var hotelCategoryOptionsIndex = 0; hotelCategoryOptionsIndex < hotelCategoryOptions.length; hotelCategoryOptionsIndex++) {
            var option = hotelCategoryOptions[hotelCategoryOptionsIndex];
            if (option.queryParams.HOTEL_CATEGORY === void 0) {
                option.value = null;
            }
            else {
                option.value = option.queryParams.HOTEL_CATEGORY;
            }
            delete option.queryParams;
        }
        var defaultHotelCategory = {
            uiValue: {
                text: Vue.translate('any'),
                options: hotelCategoryOptions
            },
            value: null,
        };
        var confirmedHotelCategory = UrlMapper.mapHotelCategoryConfirmedValue(JSON.parse(JSON.stringify(defaultHotelCategory)), productQuery);
        var indexHotelBoardCodes = formData.optionGroups.map(function (e) { return e.id; }).indexOf(1400);
        var hotelBoardCodesOptions = JSON.parse(JSON.stringify(formData.optionGroups[indexHotelBoardCodes].options));
        for (var hotelBoardCodesOptionsIndex = 0; hotelBoardCodesOptionsIndex < hotelBoardCodesOptions.length; hotelBoardCodesOptionsIndex++) {
            var option = hotelBoardCodesOptions[hotelBoardCodesOptionsIndex];
            if (!option.queryParams.HOTEL_BOARD_CODES) {
                option.value = null;
            }
            else {
                option.value = option.id;
            }
            delete option.queryParams;
        }
        var defaultHotelBoardCode = {
            uiValue: {
                text: Vue.translate('any'),
                options: hotelBoardCodesOptions
            },
            value: null,
        };
        var confirmedHotelBoardCode = UrlMapper.mapHotelBoardCodeConfirmedValue(defaultHotelBoardCode, productQuery);
        var defaultHotelRoomCode = {
            uiValue: null,
            value: null,
        };
        var confirmedHotelRoomCode = UrlMapper.mapHotelRoomCodeConfirmedValue(defaultHotelRoomCode, productQuery);
        var defaultHotelRecommendations = {
            uiValue: null,
            value: null,
        };
        var confirmedHotelRecommendations = UrlMapper.mapHotelRecommendationsConfirmedValue(defaultHotelRecommendations, productQuery);
        var defaultHotelRating = {
            uiValue: null,
            value: null,
        };
        var confirmedHotelRating = UrlMapper.mapHotelRatingConfirmedValue(defaultHotelRating, productQuery);
        var defaultLocation = {
            uiValue: null,
            value: null,
        };
        var confirmedLocation = UrlMapper.mapLocationConfirmedValue(defaultLocation, productQuery);
        var defaultFeatures = {
            uiValue: null,
            value: null,
        };
        var defaultOtherCodes = {
            uiValue: null,
            value: {}
        };
        var confirmedOtherCodes = UrlMapper.mapOtherCodesConfirmedValue(defaultOtherCodes, productQuery);
        var confirmedFeatures = UrlMapper.mapFeaturesConfirmedValue(defaultFeatures, productQuery);
        var defaultTargetGroups = {
            uiValue: null,
            value: null,
        };
        var confirmedTargetGroups = UrlMapper.mapTargetGroupsConfirmedValue(defaultTargetGroups, productQuery);
        var defaultSports = {
            uiValue: null,
            value: null,
        };
        var confirmedSports = UrlMapper.mapSportsConfirmedValue(defaultSports, productQuery);
        var defaultWintersports = {
            uiValue: null,
            value: null,
        };
        var confirmedWintersports = UrlMapper.mapWintersportsConfirmedValue(defaultWintersports, productQuery);
        var defaultWellness = {
            uiValue: null,
            value: null,
        };
        var confirmedWellness = UrlMapper.mapWellnessConfirmedValue(defaultWellness, productQuery);
        var defaultFamily = {
            uiValue: null,
            value: null,
        };
        var confirmedFamily = UrlMapper.mapFamilyConfirmedValue(defaultFamily, productQuery);
        var defaultRoomCharacteristics = {
            uiValue: null,
            value: null,
        };
        var confirmedRoomCharacteristics = UrlMapper.mapRoomCharacteristicsConfirmedValue(defaultRoomCharacteristics, productQuery);
        var defaultAccommodationTypeCode = {
            uiValue: null,
            value: null,
        };
        var confirmedAccommodationTypeCode = UrlMapper.mapAccommodationTypeCodeConfirmedValue(defaultAccommodationTypeCode, productQuery);
        var defaultDeals = {
            uiValue: null,
            value: null,
        };
        var confirmedDeals = UrlMapper.mapDealsConfirmedValue(defaultDeals, productQuery);
        var defaultTravelThemes = {
            uiValue: null,
            value: null,
        };
        var confirmedTravelThemes = UrlMapper.mapTravelThemesConfirmedValue(defaultTravelThemes, productQuery);
        var defaultFlightDepartureTimeRange = {
            uiValue: null,
            value: null,
        };
        var confirmedFlightDepartureTimeRange = UrlMapper.mapFlightDepartureTimeRangeConfirmedValue(defaultFlightDepartureTimeRange, productQuery);
        var defaultFlightReturnTimeRange = {
            uiValue: null,
            value: null,
        };
        var confirmedFlightReturnTimeRange = UrlMapper.mapFlightReturnTimeRangeConfirmedValue(defaultFlightDepartureTimeRange, productQuery);
        var defaultFlightStopOverMax = {
            uiValue: null,
            value: null,
        };
        var confirmedFlightStopOverMax = UrlMapper.mapFlightStopOverMaxConfirmedValue(defaultFlightDepartureTimeRange, productQuery);
        var defaultFlightIgnoreOpenJaw = {
            uiValue: null,
            value: null,
        };
        var confirmedFlightIgnoreOpenJaw = UrlMapper.mapFlightIgnoreOpenJawConfirmedValue(defaultFlightDepartureTimeRange, options);
        var defaultPriceRange = {
            uiValue: Vue.translate('any'),
            value: {
                "priceMin": null,
                "priceMax": null,
                "currencySymbol": Currency.getSymbol(formData.context.currency),
                "maxValue": 6000,
                "minValue": 0,
                "step": 100
            }
        };
        var confirmedPriceRange = UrlMapper.mapPriceRangeConfirmedValue(defaultPriceRange, productQuery);
        var defaultTransfer = {
            uiValue: null,
            value: false
        };
        var confirmedTransfer = UrlMapper.mapTransferConfirmedValue(defaultTransfer, productQuery);
        var defaultTrainToFlight = {
            uiValue: null,
            value: false
        };
        var confirmedTrainToFlight = UrlMapper.mapTrainToFlightConfirmedValue(defaultTransfer, productQuery);
        var defaultFlex = {
            uiValue: null,
            value: false
        };
        var confirmedFlex = UrlMapper.mapFlexConfirmedValue(defaultFlex, query);
        var defaultPagination = {
            uiValue: null,
            value: {
                page: 0,
                size: 10,
                sorting: ['price']
            }
        };
        var confirmedPagination = UrlMapper.mapPaginationConfirmedValue(defaultPagination, query);
        this.searchMaskGroups[SearchMaskGroupType.PACKAGE] = {
            inputs: (_a = {},
                _a[SearchMaskInputType.DEPARTURE_AIRPORT] = {
                    defaultValue: JSON.parse(JSON.stringify(airportInitValue)),
                    confirmedValue: JSON.parse(JSON.stringify(airportInitValueConfirmedValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.DEPARTURE_AIRPORT,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(airportInitValueConfirmedValue, SearchMaskGroupType.PACKAGE, SearchMaskInputType.DEPARTURE_AIRPORT)
                },
                _a[SearchMaskInputType.DESTINATION] = {
                    confirmedValue: JSON.parse(JSON.stringify(UrlMapper.mapDestinationConfirmedValue(SearchMaskGroupType.PACKAGE, JSON.parse(JSON.stringify(destinationInitValue)), productQuery, productGroupId))),
                    defaultValue: JSON.parse(JSON.stringify(destinationInitValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.DESTINATION,
                    coreQuery: destinationCoreQuery,
                },
                _a[SearchMaskInputType.FEATURES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFeatures)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFeatures)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FEATURES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFeatures, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FEATURES)
                },
                _a[SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFlightDepartureTimeRange)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFlightDepartureTimeRange)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlightDepartureTimeRange, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE)
                },
                _a[SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFlightReturnTimeRange)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFlightReturnTimeRange)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlightReturnTimeRange, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE)
                },
                _a[SearchMaskInputType.FLIGHT_STOP_OVER_MAX] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFlightStopOverMax)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFlightStopOverMax)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FLIGHT_STOP_OVER_MAX,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlightStopOverMax, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_STOP_OVER_MAX)
                },
                _a[SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFlightIgnoreOpenJaw)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFlightIgnoreOpenJaw)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW,
                    coreOptions: UserInputValueToCoreMapper.mapOptions(confirmedFlightIgnoreOpenJaw, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLIGHT_IGNORE_OPEN_JAW)
                },
                _a[SearchMaskInputType.HOTEL_CATEGORY] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelCategory)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelCategory)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_CATEGORY,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelCategory, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_CATEGORY)
                },
                _a[SearchMaskInputType.HOTEL_BOARD_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelBoardCode)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelBoardCode)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_BOARD_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelBoardCode, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_BOARD_CODES)
                },
                _a[SearchMaskInputType.HOTEL_ROOM_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelRoomCode)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRoomCode)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_ROOM_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRoomCode, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_ROOM_CODES)
                },
                _a[SearchMaskInputType.HOTEL_RECOMMENDATIONS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelRecommendations)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRecommendations)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_RECOMMENDATIONS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRecommendations, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_RECOMMENDATIONS)
                },
                _a[SearchMaskInputType.HOTEL_RATING] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultHotelRating)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedHotelRating)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.HOTEL_RATING,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedHotelRating, SearchMaskGroupType.PACKAGE, SearchMaskInputType.HOTEL_RATING)
                },
                _a[SearchMaskInputType.LOCATION] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultLocation)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedLocation)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.LOCATION,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedLocation, SearchMaskGroupType.PACKAGE, SearchMaskInputType.LOCATION)
                },
                _a[SearchMaskInputType.OTHER_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultOtherCodes)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedOtherCodes)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.OTHER_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedOtherCodes, SearchMaskGroupType.PACKAGE, SearchMaskInputType.OTHER_CODES)
                },
                _a[SearchMaskInputType.SPORTS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultSports)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedSports)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.SPORTS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedSports, SearchMaskGroupType.PACKAGE, SearchMaskInputType.SPORTS)
                },
                _a[SearchMaskInputType.WINTERSPORTS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultWintersports)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedWintersports)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.WINTERSPORTS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedWintersports, SearchMaskGroupType.PACKAGE, SearchMaskInputType.WINTERSPORTS)
                },
                _a[SearchMaskInputType.WELLNESS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultWellness)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedWellness)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.WELLNESS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedWellness, SearchMaskGroupType.PACKAGE, SearchMaskInputType.WELLNESS)
                },
                _a[SearchMaskInputType.ACCOMMODATION_TYPE_CODES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultAccommodationTypeCode)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedAccommodationTypeCode)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.ACCOMMODATION_TYPE_CODES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedAccommodationTypeCode, SearchMaskGroupType.PACKAGE, SearchMaskInputType.ACCOMMODATION_TYPE_CODES)
                },
                _a[SearchMaskInputType.FAMILY] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFamily)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFamily)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FAMILY,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFamily, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FAMILY)
                },
                _a[SearchMaskInputType.ROOMCHARACTERISTICS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultRoomCharacteristics)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedRoomCharacteristics)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.ROOMCHARACTERISTICS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedRoomCharacteristics, SearchMaskGroupType.PACKAGE, SearchMaskInputType.ROOMCHARACTERISTICS)
                },
                _a[SearchMaskInputType.DEALS] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultDeals)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedDeals)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.DEALS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedDeals, SearchMaskGroupType.PACKAGE, SearchMaskInputType.DEALS)
                },
                _a[SearchMaskInputType.TRAVEL_THEMES] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultTravelThemes)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedTravelThemes)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.TRAVEL_THEMES,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTravelThemes, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAVEL_THEMES)
                },
                _a[SearchMaskInputType.PAGINATION] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultPagination)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedPagination)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.PAGINATION,
                },
                _a[SearchMaskInputType.PRICE_RANGE] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultPriceRange)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedPriceRange)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.PRICE_RANGE,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedPriceRange, SearchMaskGroupType.PACKAGE, SearchMaskInputType.PRICE_RANGE)
                },
                _a[SearchMaskInputType.TARGET_GROUPS] = {
                    confirmedValue: JSON.parse(JSON.stringify(confirmedTargetGroups)),
                    defaultValue: JSON.parse(JSON.stringify(defaultTargetGroups)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.TARGET_GROUPS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTargetGroups, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TARGET_GROUPS)
                },
                _a[SearchMaskInputType.TRAVEL_PERIOD] = {
                    confirmedValue: JSON.parse(JSON.stringify(travelPeriodConfirmedValue)),
                    defaultValue: JSON.parse(JSON.stringify(travelPeriodDefaultValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.TRAVEL_PERIOD,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(travelPeriodConfirmedValue, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAVEL_PERIOD)
                },
                _a[SearchMaskInputType.TRAVELLERS] = {
                    confirmedValue: JSON.parse(JSON.stringify(travellersConfirmedValue)),
                    defaultValue: JSON.parse(JSON.stringify(travellersDefaultValue)),
                    modalIsInitialized: false,
                    type: SearchMaskInputType.TRAVELLERS,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(travellersConfirmedValue, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAVELLERS),
                },
                _a[SearchMaskInputType.TRANSFER] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultTransfer)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedTransfer)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.TRANSFER,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTransfer, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRANSFER)
                },
                _a[SearchMaskInputType.TRAIN_TO_FLIGHT] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultTrainToFlight)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedTrainToFlight)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.TRAIN_TO_FLIGHT,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedTrainToFlight, SearchMaskGroupType.PACKAGE, SearchMaskInputType.TRAIN_TO_FLIGHT)
                },
                _a[SearchMaskInputType.FLEX] = {
                    defaultValue: JSON.parse(JSON.stringify(defaultFlex)),
                    confirmedValue: JSON.parse(JSON.stringify(confirmedFlex)),
                    modalIsInitialized: true,
                    type: SearchMaskInputType.FLEX,
                    coreQuery: UserInputValueToCoreMapper.mapQuery(confirmedFlex, SearchMaskGroupType.PACKAGE, SearchMaskInputType.FLEX)
                },
                _a),
            initialized: true,
            type: SearchMaskGroupType.PACKAGE
        };
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.HOTEL] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.HOTEL] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.HOTEL
            };
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.LAST_MINUTE] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.LAST_MINUTE
            };
        }
        if (typeof searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] === 'undefined') {
            searchMaskBundle.groups[SearchMaskGroupType.FLIGHT] = {
                inputs: {},
                initialized: false,
                type: SearchMaskGroupType.FLIGHT
            };
        }
        searchMaskBundle.groups[SearchMaskGroupType.PACKAGE] = this.searchMaskGroups[SearchMaskGroupType.PACKAGE];
        store.dispatch(websiteActions.setSearchMaskBundle(searchMaskBundle));
        searchMaskBundle.groups[SearchMaskGroupType.RAIL_PACKAGE] = null;
        store.dispatch(websiteActions.setSearchMaskBundle(searchMaskBundle));
    };
    ;
    InputValueSetup.prototype.extractAirportCodes = function (departureAirportParsed) {
        var airportCodes = [];
        departureAirportParsed.forEach(function (element) {
            airportCodes.push(element.code);
        });
        return airportCodes;
    };
    return InputValueSetup;
}());
export default InputValueSetup;
